import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const tomi = [{
  emoji: '📘',
  title: 'Rechtssicherheit & Verträge',
  subtitle: '60 Seiten | OR & ZGB Aktualisiert 2026',
  bullets: ['Entstehung und Aufbau von Verträgen (Art. 1–40 OR)', 'Konsumentenschutz im E-Commerce', 'Mietrecht: Die häufigsten Streitfälle erklärt', 'Druckfertige Arbeitsblätter für jede Lektion']
}, {
  emoji: '📗',
  title: 'Die Schweizer Volkswirtschaft',
  subtitle: '60 Seiten | SNB & Konjunktur 2026',
  bullets: ['Der Schweizer Franken und die SNB-Geldpolitik', 'Inflation, Beschäftigung und Konjunkturzyklen', 'Aussenhandel und Zahlungsbilanz der Schweiz', 'Übungen mit realen SECO-Daten']
}, {
  emoji: '📙',
  title: 'Betriebswirtschaft & Strategie',
  subtitle: '60 Seiten | KMU Schweiz Edition',
  bullets: ['Das St. Galler Management-Modell', 'Rechtsformen in der Schweiz: GmbH vs. AG', 'Marketing-Mix für den Schweizer Markt', 'Bilanz und Erfolgsrechnung für den Unterricht']
}, {
  emoji: '📒',
  title: 'Arbeitswelt & Sozialversicherungen',
  subtitle: '60 Seiten | EAV, GAV & 3-Säulen-System',
  bullets: ['Einzel- und Gesamtarbeitsvertrag im Detail', 'Das 3-Säulen-System der Schweizer Vorsorge', 'Lohnabrechnungs-Simulator für den Unterricht', 'AHV, BVG, ALV und SUVA klar erklärt']
}, {
  emoji: '📓',
  title: 'Finanzielle Alphabetisierung',
  subtitle: '60 Seiten | Junge Erwachsene Schweiz',
  bullets: ['Reales Monatsbudget für Schweizer Jugendliche', 'Krankenkasse einfach erklärt (KVG/VVG)', 'Einstieg in die Schweizer Börse (SIX)', 'Steuerplanung für Erstverdiener']
}, {
  emoji: '📔',
  title: 'Ethik, Umwelt & Nachhaltigkeit',
  subtitle: '60 Seiten | ESG & CSR Schweiz 2026',
  bullets: ['Soziale Verantwortung Schweizer Unternehmen', 'Lieferkettensorgfaltspflicht und globale Auswirkungen', 'Greenwashing vs. echte Nachhaltigkeitspraxis', 'Strukturierte Klassendebatte: Profit vs. Ethik']
}];
export function TomiSection() {
  return <section className="py-10 px-4 bg-swiss-card-bg border-y border-gray-200" data-id="element-192">
      <div className="max-w-2xl mx-auto" data-id="element-193">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-center text-swiss-charcoal mb-8" data-id="element-194">
          Was Sie erhalten: Die 6 Kernmodule
        </motion.h2>

        <div className="space-y-4" data-id="element-195">
          {tomi.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-gray-200 rounded-xl p-5 sm:p-6 shadow-sm" data-id="element-196">
              <div className="flex items-start gap-3 mb-4" data-id="element-197">
                <span className="text-3xl sm:text-4xl leading-none" data-id="element-198">
                  {t.emoji}
                </span>
                <div data-id="element-199">
                  <div className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-200">
                    TOMO {i + 1}
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-swiss-charcoal leading-tight" data-id="element-201">
                    {t.title}
                  </h3>
                  <p className="text-sm text-gray-500 mt-1 font-medium" data-id="element-202">
                    {t.subtitle}
                  </p>
                </div>
              </div>
              <div className="space-y-2 mt-4" data-id="element-203">
                {t.bullets.map((bullet, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-204">
                    <CheckIcon className="w-5 h-5 text-swiss-green-cta shrink-0 mt-0.5" data-id="element-205" />
                    <span className="text-sm sm:text-base text-gray-700" data-id="element-206">
                      {bullet}
                    </span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}